/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';

import { ModifyShareNameComponent } from './modify-share-name.component';

@NgModule({
    declarations: [ModifyShareNameComponent],
    exports: [ModifyShareNameComponent],
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
    ],
})
export class ModifyShareNameModule { }
